
export const APP_NAME = "NLocale";
export const APP_DESCRIPTION = "Découvrez l'Aisne comme un local";

export const ROUTES = {
  HOME: "/",
  PRO: "/pro",
  INDIVIDUAL: "/particulier",
  PRIVACY: "/confidentialite",
  LEGAL: "/mentions-legales",
} as const;

export const WAITLIST_MESSAGES = {
  SUCCESS: "Merci ! Vous recevrez bientôt de nos nouvelles.",
  ERROR: "Une erreur est survenue, veuillez réessayer.",
  ALREADY_REGISTERED: "Cette adresse email est déjà inscrite.",
} as const;

export const SOCIAL_LINKS = {
  FACEBOOK: "https://facebook.com/nlocale",
  TWITTER: "https://twitter.com/nlocale",
  INSTAGRAM: "https://instagram.com/nlocale",
} as const;
